import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { VildVersion, VildVersionExtended } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const vildVersionsUrl = `${environment.apiUrl}/vildversions`;
const vildVersionsActual = `${vildVersionsUrl}/actual`;
const vildVersionForIdUrl = (id: number) => `${vildVersionsUrl}/${id}`;
const approveVildVersionUrl = (id: number) => `${vildVersionForIdUrl(id)}/approve`;

@Injectable()
export class VildVersionService {
  constructor(private readonly httpService: HttpService) {}

  getVildVersions(): Observable<VildVersion[]> {
    return this.httpService.get<VildVersion[]>(vildVersionsUrl);
  }

  getVildVersion(id: number): Observable<VildVersion> {
    return this.httpService.get<VildVersion>(vildVersionForIdUrl(id));
  }

  getActualVildVersions(): Observable<VildVersion[]> {
    return this.httpService.get<VildVersion[]>(vildVersionsActual);
  }

  deleteVildVersion(id: number): Observable<boolean> {
    return this.httpService.delete(vildVersionForIdUrl(id)).map(response => response.json() as boolean);
  }

  newVildVersion(vildVersionExt: VildVersionExtended): Observable<void> {
    const formData: FormData = new FormData();

    // append JSON data
    formData.append(
      'vild',
      new Blob([JSON.stringify(vildVersionExt.vildVersion)], {
        type: 'application/json'
      })
    );

    // append all files
    for (const fileField of Object.keys(vildVersionExt)) {
      if (fileField.startsWith('file_')) {
        const shortName = fileField.substr('file_'.length);
        formData.append(shortName, vildVersionExt[fileField]);
      }
    }

    return this.httpService.postFile(
      vildVersionsUrl,
      formData,
      this.httpService.headersWithCredentialsWithoutContentType()
    );
  }

  approveVildVersion(id: number): Observable<void> {
    const url = approveVildVersionUrl(id);
    return this.httpService.post(url, {});
  }

  hasFutureVildVersion(): Observable<boolean> {
    return this.getVildVersions().map(
      vildVersions => vildVersions && vildVersions.length > 0 && new Date(vildVersions[0].startdate) > new Date()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/vild-version.service.ts